import React__default from "react";
import { RouterContext } from "./router-context.mjs";
const RouterProvider = ({ children, navigate }) => {
  const router = React__default.useMemo(() => ({ navigate }), [navigate]);
  return /* @__PURE__ */ React__default.createElement(RouterContext.Provider, { value: router }, children);
};
export {
  RouterProvider
};
